import {useIsFocused, useRoute} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {RFValue} from 'react-native-responsive-fontsize';

import {StationDTO} from '../../../dtos/StationDTO';

import {api} from '../../../services/api';

import {Header} from '../../../components/Interface/Headers/Header';
import {Loading} from '../../../components/Interface/Loadings/Loading';

import {Container, Content, Title, StationsList} from './styles';

import {StationItem} from '../../../components/shared/Stations/StationItem';
import {SearchInput} from '../../../components/Interface/Forms/Inputs/SearchInput';
import {NotFound} from '../../../components/Interface/Search/NotFound';

interface Route {
  voucherId: string;
  region: string;
  tipo: string;
}

export function CouponStationsNovo() {
  const routes = useRoute();
  const screenIsFocus = useIsFocused();

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStationsBySearchTerm, setFilteredStationsBySearchTerm] =
    useState<StationDTO[]>([] as StationDTO[]);

  const [data, setData] = useState<StationDTO[]>([] as StationDTO[]);
  const [isLoading, setIsLoading] = useState(true);

  const {voucherId, tipo} = routes.params as Route;

  useEffect(() => {
    let isMounted = true;

    async function fetchStations() {
      try {
        await api
          .get('/listaPostos', {
            params: {
              voucher_id: voucherId,
            },
          })
          .then(response => {
            const stations = response.data;

            if (isMounted) {
              setData(stations);
              setIsLoading(false);
            }
          })
          .catch(() => {
            if (isMounted) {
              setIsLoading(false);
            }
          });
      } catch (error) {
        console.log(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
          isMounted = false;
        }
      }
    }

    fetchStations();

    return () => {
      isMounted = false;
    };
  }, [screenIsFocus]);

  function handleSearchStations(name: string) {
    const filter = data.filter(
      (e: StationDTO) =>
        e.name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          ) ||
        e.neighbourhood
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          ) ||
        e.flag
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            name
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          ),
    );

    setFilteredStationsBySearchTerm(filter);
    setSearchTerm(name);
  }

  return (
    <Container>
      <Header icon="chevron-left" />

      {isLoading && <Loading />}

      <Content
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{paddingBottom: RFValue(20)}}>
        {tipo === 'C' ? (
          <>
            <Title>Postos disponíveis</Title>

            <SearchInput
              placeholder="Buscar por nome do posto" // Após arrumar a barra de pesquisa, voltar com bairro e bandeira
              value={searchTerm}
              onChangeText={text => handleSearchStations(text)}
            />
          </>
        ) : (
          <>
            <Title>Pontos disponíveis</Title>

            <SearchInput
              placeholder="Buscar por nome ou bairro"
              value={searchTerm}
              onChangeText={text => handleSearchStations(text)}
            />
          </>
        )}

        <StationsList>
          {data.length !== 0 && searchTerm.length ? (
            filteredStationsBySearchTerm.length !== 0 ? (
              filteredStationsBySearchTerm.map(item => (
                <StationItem data={item} key={item.id} showRank={false} />
              ))
            ) : (
              <NotFound />
            )
          ) : (
            data.map(item => (
              <StationItem data={item} key={item.id} showRank={false} />
            ))
          )}
        </StationsList>
      </Content>
    </Container>
  );
}
